import TomSelect from "tom-select/dist/esm/tom-select.complete.js";

export default TomSelect;
export type { default as TomSelectInstance } from "tom-select";
